<div style="height: 400px; overflow: auto">
  <div *ngIf="columns.length > 0" class="wrapper">
    <div class="wrapper-column" *ngFor="let column of columns">
      <div
        (click)="itemSelected(column.Index, item)"
        class="action-button"
        [class.clicked]="item.IsClicked && (isItemSelected(item) || !item.Id)"
        [class.selected]="isItemSelected(item) && !item.IsClicked"
        *ngFor="let item of column.Items"
      >
        <span *ngIf="item.Id">
          <mat-icon *ngIf="isItemSelected(item) && !item.StepTargetId"
            >done</mat-icon
          >
          {{ item.Name }}
        </span>
        <span *ngIf="!item.Id"> {{ item.Name }} </span>

      </div>
    </div>
  </div>


</div>
<div *ngFor="let item of getSelection()">
  <div [innerHTML]="item"></div>
</div>
